import { keyframes, styled } from "goober";
import type { ComponentProps, ReactNode } from "react";
import { Noodle } from "../Noodle";

const fadeInSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: stretch;
  max-width: 100%;
  overflow: hidden;
  animation: ${fadeInSlideUp} var(--motion-fast) var(--ease-out);
  &[data-connected="true"] {
    margin-left: 12px;
  }
  &[data-connected="false"] {
    animation: none;
  }
`;

const Inner = styled("div")`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  overflow: hidden;
`;

const NoodleColumn = styled("div")`
  width: 12px;
  align-self: stretch;
  display: flex;
`;

export function ActivityRow({
  connected,
  hasNext,
  variant = hasNext ? "branch" : "terminate",
  children,
}: {
  connected: boolean;
  hasNext: boolean;
  variant?: ComponentProps<typeof Noodle>["variant"];
  children: ReactNode;
}) {
  return (
    <Container data-connected={connected}>
      {connected && (
        <NoodleColumn aria-hidden>
          <Noodle gridSize={7} variant={variant} />
        </NoodleColumn>
      )}
      <Inner>{children}</Inner>
    </Container>
  );
}
